import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getSessionAction } from "@/actions/serverActions/auth/getSessionAction";
import { API_URL } from "@/baseUrl";

/**
 * Read the access token from the encrypted Redis session via a server action.
 * Server actions can be invoked from the browser (Next handles the RPC), so
 * this stays a client-safe helper.
 */
const getTokenFromSession = async (): Promise<string | null> => {
  if (typeof window === "undefined") return null;
  try {
    const session = await getSessionAction();
    return session?.accessToken || null;
  } catch (error) {
    console.error("[apiSlice] Failed to fetch session token:", error);
    return null;
  }
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL as string,
    credentials: "include",
    prepareHeaders: async (headers) => {
      // Multi-tenant: Django routes by hostname
      if (typeof window !== "undefined") {
        headers.set("X-Dev-Domain", window.location.host);
      }

      const token = await getTokenFromSession();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  tagTypes: [],
  endpoints: (_builder) => ({}),
  refetchOnFocus: true,
  refetchOnReconnect: true,
});
